import confirmation from './confirmation.json';

export default {
  'update-identity-document': {
    ...confirmation,
    ine_no_expired: 'Tu INE no ha expirado, aún cuenta con validez, te estamos redirigiendo',
  },
};
